import {QueryCommand} from "xmgoing-server";
import {StorageUtils} from 'xmgoing-utils';
import {GoingNewUtils} from "xmgoing-utils";
import GoingUtils from "@/utils/goingUtils";

/**
 * 保存列设置信息
 * @param data
 */
export const saveColsConfig = function (data, backFun, failFun?: any) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/dataManage/save`,
    method: 'POST'
  });
  queryCommand.executeQueryPromise({params: {...data}}).then((res: any) => {
    backFun && backFun(res);
  }).catch((err: any) => {
    GoingUtils.showErrorMessage(err?.msg || err?.message || '保存列配置失败');
    failFun && failFun(err);
  });
}


/**
 * 清空本人保存的配置信息
 * @param data
 */
export const clearColsConfig = function (data, backFun) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/dataManage/clearByPageId`,
    method: 'POST'
  });
  queryCommand.executeQueryPromise({params: {...data}}).then((des: any) => {
    StorageUtils.removeSessionItem(data.pageId + "ColumnsConfig");
    GoingUtils.showMessage("操作成功！");
    backFun && backFun(des);
  });
}

/**
 * 获取列设置信息
 * @param data
 */
export const getDetailByPageId = async function ({pageId}, userFieldConfigCols,subGridKey,mainPageColConfigCode) {
  if (pageId == null || pageId === '') {
    return;
  }
  const res = StorageUtils.getSessionItem(pageId + "ColumnsConfigDb");
  if (res) {
    try {
      return JSON.parse(res);
    } catch (e) {
      StorageUtils.removeSessionItem(pageId + "ColumnsConfig");
      getDetailByPageId({pageId}, userFieldConfigCols,subGridKey,mainPageColConfigCode);
    }
  }
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/dataManage/detailByPageId`,
    method: 'GET'
  });
  const queryParams = {
    pageId: (pageId + ''),
    userDomain: true,
    size: GoingNewUtils.maxPageSize
  };
  if (userFieldConfigCols) {
    queryParams['subGridConfig'] = true;
  }
  if (subGridKey) {
    queryParams['subGridKey'] = subGridKey;
  }
  if (mainPageColConfigCode) {
    queryParams['mainPageColConfigCode'] = mainPageColConfigCode;
  }
  return queryCommand.executeQueryPromise({
    params: queryParams
  });
}
